import styled, { css } from 'styled-components'

import { PriceWrapper } from '@/components/Price/Price.styles'
import { Reset, TransitionPrimary } from '@/lib/mixins'

export const CartButtonWrapper = styled.button`
  ${Reset('button')}
  ${TransitionPrimary('background-color, border-color, opacity')}
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 4.25rem;
  padding: 0.35rem 1rem 0.35rem 1.5rem;
  background-color: ${props => props.theme.color.primary};
  color: ${props => props.theme.color.inverted};
  border: 1px solid ${props => props.theme.color.primaryMedium};
  gap: 1.15rem;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.55;
      pointer-events: none;
    `};
`

export const CartButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${props => props.theme.color.mutedInverted};
    flex-shrink: 0;
    margin-right: 0.55rem;
  }
`

export const CartButtonLabel = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.color.mutedInverted};
  white-space: nowrap;
  margin-right: 0.55rem;
`

export const CartButtonPrice = styled.span`
  ${PriceWrapper} {
    font-size: 1.55em;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }
`

export const CartButtonArrow = styled.span`
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
  background-color: ${props => props.theme.color.secondary};
  color: ${props => props.theme.color.primaryDark};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-top: 0.15rem solid currentColor;
    border-right: 0.15rem solid currentColor;
    transform: rotate(45deg);
    margin-left: -0.35rem;
  }
`
